// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.SKduw{background:var(--whitelabeling-secondary-color);border-radius:4px;color:#fff;display:inline-block;font-size:11px;font-weight:600;letter-spacing:.92px;line-height:13px;margin-bottom:10px;padding:7px;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"livestreamStartBadge": "SKduw"
};
module.exports = ___CSS_LOADER_EXPORT___;
